import React, {useState, useCallback} from 'react';
import {Box} from "@mui/material";
import {QuizQuestion} from "./QuizQuestion";

function updateQuestionAnswer(questionList, questionId, answer) {
    return questionList.map(item => {
        const newItem = { ...item };
        if (newItem.id === questionId) {
            newItem.answerOptionId = answer;
        }
        if (Array.isArray(newItem.options)) {
            newItem.options = newItem.options.map(option => {
                const newOption = { ...option };
                if (Array.isArray(option.childQuestions)) {
                    newOption.childQuestions = updateQuestionAnswer(option.childQuestions, questionId, answer);
                }
                return newOption;
            });
        }
        return newItem;
    });
}

export const NewQuizQuestions = ({
                                     questionList,
                                     disabled,
                                     onChangeQuestion
                                 }) => {

    const onChangeAnswer = (value, questionId) => {
        onChangeQuestion(updateQuestionAnswer(questionList, questionId, value));
    }

    const renderQuestion = (question) => {
        return <Box mb={2} key={question.id}>
            <QuizQuestion
                question={question}
                truth={question.truthOptionId}
                answer={question.answerOptionId}
                disabled={disabled}
                onChange={(value, id) => onChangeAnswer(value, id ?? question.id)}
            />
            {question.questionExplain && <Box mt={1} mb={2} dangerouslySetInnerHTML={{__html: question.questionExplain}}></Box>}
        </Box>
    }

    return (
        <div className="dynamic-questions" style={{flex: 1}}>
            <Box px={1}>
                {questionList.map(question => renderQuestion(question))}
            </Box>
        </div>
    );
};
